<template>
    <div class="home">


        <iframe width="100%" height="1080" src="https://www.youtube.com/embed/D5bf9Iolzs8?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <h5 class="display-title-strong  text-dark">Das Video ist sehr intressant!</h5>
        <div class="container">

        </div>

        <div class="main-title">


            <br class="no-move"/>
            <br class="no-move"/>

            <div class="container">

                <p class="body-title-lighter-lighter text-dark">
                    Hey Maro , ich kenne dich ja jetzt schon ein bisschen länger , angefangen hat es mit einen VoiceMute auf GommeHD haha :p .
                    Jetzt sind wir beide im selben Team und du bist mir mega sympathisch geworden , danke das ich im Labyhelp Team sein darf.
                    Ich habe mir viel mühe für das Video gegeben , leider ist die Quali flöten gegangen , da ich PROFI alles in MKV aufgenommen
                    habe und Sony Vegas keine MKV unterstützt und somit musste ich nochmal alles umwandeln in Mp4 naja , aber das Video ist
                    gut geworden und ich danke dir für alles!  <br class="no-move"/>
                    <code>von Florian / LabyFloo für dich Maro</code>

                    <br class="no-move"/>
                    <br class="no-move"/>
                    <br class="no-move"/>

                    Sehr gute Persönlichkeit und Führungskraft. Sehr sympathischer Mensch der für einen da ist sollten Probleme oder Fragen aufkommen.
                    xela
                    Du bist zwar manchmal ziemlich lost, bist aber echt nett und es macht echt Spaß mit dir zu reden. Und als SrMod finde ich, machst du deinen Job richtig gut.
                    <br class="no-move"/>
                    <code>von Eierlieferant für dich Maro</code>

                    <br class="no-move"/>
                    <br class="no-move"/>
                    <br class="no-move"/>

                    Hallo Maro

                    Hiermit möchte ich dir zum Administrator rang gratulieren
                    ich hoffe weiterhin auf eine gute zusammen Arbeit und das du LabyHelp weiterhin sicher machst
                    Und wir wünschen dir alle vom LabyHelp Team alles gute
                    <br class="no-move"/>
                    <code>von Ulmsii für dich Maro</code>

                    <br class="no-move"/>
                    <br class="no-move"/>
                    <br class="no-move"/>

                    Sehr gute Persönlichkeit und Führungskraft. Sehr sympathischer Mensch der für einen da ist sollten Probleme oder Fragen aufkommen.

                    <br class="no-move"/>
                    <code>von cacyy für dich Maro</code>

                    <br class="no-move"/>
                    <br class="no-move"/>
                    <br class="no-move"/>

                    Auch wenn ich es nicht gerne zugebe und es mir auch sehr schwer fällt, aber du bist besser als ich in Rocket League
                    <br class="no-move"/>
                    <code>von Eddie für dich Maro</code>

                    <br class="no-move"/>
                    <br class="no-move"/>
                    <br class="no-move"/>

                    Ich finde Maro hat seinen Job schon immer ziemlich gut gemacht. Er darf nur nicht zu abgehoben werden, wenn er Administrator ist.
                    <br class="no-move"/>
                    <code>von Adrian für dich Maro</code>
                    <br class="no-move"/>
                    <br class="no-move"/>
                    <br class="no-move"/>

                    Hey Maro!
                    Nochmals möchte ich dir mit dieser Nachricht gratulieren. Ich bin unfassbar froh das wir uns kennengelernt haben. Du machst deine Aufgaben im Labyhelp Team sensationell, und bist zudem ein wirklich sehr sympatischer Mensch. Auch wenn du es nicht zugeben willst aber ich bin und bleibe in BedWars der beste xD.  Ich freue mich weiterhin mit dir im Team zu arbeiten zu dürfen und hoffe auf schöne weitere Jahre sowohl freundschaftilich als auch im Team.
                    <br class="no-move"/>
                    <code>von _Super_Hero für dich Maro</code>

                </p>

                <br class="no-move"/>
                <br class="no-move"/>

                <h5 class="display-title-strong  text-dark">Viel Spaß!</h5>
                <p class="body-title-lighter-lighter text-dark"><code>von Marvin für dich Maro</code></p>

            </div>

            <br class="no-move"/>

            <div class="" style="alignment: bottom">

                <div class="" style="alignment: bottom">
                    <p class="smaller-end-text">© {{ today.getFullYear() }}
                        <a style="color: #6868b3" href="https://labyhelp.de">LabyHelp Group</a></p>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "Team",
    data() {
        return {
            today: new Date()
        }
    },
}
</script>

<style scoped>

</style>